@if (!config.multiCheck) {
  <div [attr.aria-label]="config.name">
    <div [formGroup]="group" class="dynamic-radio {{config.class}}">
      <mat-label class="default-sub-header text-label" [tabindex]="config.label ? 0 : -1">{{config.label | translate}}</mat-label>
      <mat-radio-group [formControlName]="config.name"  [attr.name]="config.name" (change)="selectedOption($event)">
        @for (option of config.options; track option) {
          <mat-radio-button class="radio-button" [checked]="option.id == config.value" [value]='option.id' [disabled] = 'config.disabled' #radioBtn="matRadioButton"
            (keydown.enter)="radioBtn._inputElement.nativeElement.click()" (keydown.space)="radioBtn._inputElement.nativeElement.click()">
            <div class="selection-container " tabindex="0" [attr.aria-label]="option.value | translate" [ngClass]="{'icon-Check---Widget': radioBtn.checked}"></div>
            <span class="default-form-field">{{option.value | translate}}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </div>
}
@if (config.multiCheck) {
  <div>
    <mat-radio-group aria-label="Select an option" [formGroup]="group">
      @for (option of config.options; track option) {
        <mat-radio-button class="radio-button" [value]='option.id' [disabled] = 'config.disabled' >
          <div class="selection-container " tabindex="0" [attr.aria-label]="option.value" [ngClass]="{'icon-Check---Widget': dfs.selectedRadioOption == option.id}"></div>
          <span class="default-form-field" [attr.aria-label]="option.value | translate">{{option.value}}</span>
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
}